import React from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { useParams } from 'react-router-dom';
import { BaseLocationsSelectSearch } from 'src/components/SelectSearch/BaseLocationsSelectSearch';
import { ILocation } from 'src/types/Location';
import { getLocationsMap } from 'src/components/oneCorp/features/MealCredit/utils/EnterpriseManageMealCreditsPage.utils';
import { maxLocationsAllowedValidation } from 'src/components/oneCorp/features/MealCredit/components/Form/Rules/LocationsRule/hooks/selectLocationsValidation';

export interface LocationsSelectSearchProps {
  name: string;
  initValue?: Partial<ILocation>[];
  maxLocationsAllowed: number;
}

export function LocationsSelectSearch({
  name,
  initValue,
  maxLocationsAllowed,
}: LocationsSelectSearchProps): JSX.Element {
  const { setValue } = useFormContext();
  const { corpid: corpId } = useParams<{ corpid: string }>();

  return (
    <BaseLocationsSelectSearch
      name={name}
      corpId={corpId}
      label={`Add up to ${maxLocationsAllowed} locations`}
      rules={{
        validate: {
          required: (value) =>
            (value && Object.keys(value).length > 0) ||
            'You must add at least one location',
          maxLocations: maxLocationsAllowedValidation(maxLocationsAllowed),
        },
      }}
      initialSelectedValue={initValue}
      onValueChange={(locations: ILocation[] = []): void => {
        setValue(
          name,
          locations.length > 0 ? getLocationsMap(locations) : null,
          {
            shouldValidate: true,
          }
        );
      }}
    />
  );
}
